import React from "react";
import type { SvgIconProps } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import ErrorIcon from "@mui/icons-material/Error";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

import { type MachineGroupStatus } from "@/schemas";

export interface MachineGroupStatusIconProps extends SvgIconProps {
	readonly status: MachineGroupStatus;
	readonly useColor: boolean;
	readonly productionEnabled?: boolean;
}

export const MachineGroupStatusIcon: React.FC<MachineGroupStatusIconProps> = ({
	status,
	useColor,
	productionEnabled = true,
	sx,
	...props
}) => {
	switch (status) {
		case "Online":
			if (productionEnabled) {
				return <CheckCircleOutlineIcon sx={{ color: useColor ? "success.main" : "text.primary", ...sx }} {...props} />;
			}

			return <PauseCircleOutlineIcon sx={{ color: useColor ? "warning.main" : "text.primary", ...sx }} {...props} />;
		case "Offline":
		case "NoMachinesConfigured":
			return <HighlightOffIcon sx={{ color: useColor ? "text.disabled" : "text.primary", ...sx }} {...props} />;
		case "Error":
			return <ErrorIcon sx={{ color: useColor ? "error.main" : "text.primary", ...sx }} {...props} />;
		case "Initializing":
			return <RefreshIcon sx={{ color: useColor ? "text.disabled" : "text.primary", ...sx }} {...props} />;
		case "Paused":
		case "ChangingCorrugate":
			return <PauseCircleOutlineIcon sx={{ color: useColor ? "warning.main" : "text.primary", ...sx }} {...props} />;
		case "AirplaneMode":
			return <CloudOffIcon sx={{ color: useColor ? "text.disabled" : "text.primary", ...sx }} {...props} />;
		default:
			return null;
	}
};
